import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { withLang } from "./withLang";

export const avatarApi = createApi({
  reducerPath: "avatarApi",
  baseQuery: withLang(
    fetchBaseQuery({
      //Can probably create an API variables export file to manage and set all base URL's if needed later
      baseUrl: `${process.env.REACT_APP_API_BASE_URL}/apiv2/avatar/`,
    }),
  ),
  endpoints: (builder) => ({
    getAvatar: builder.mutation({
      query: (body) => ({
        url: `get`,
        method: "POST",
        body: body,
      }),
    }),
    uploadAvatar: builder.mutation({
      query: (body) => ({
        url: `upload`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const { useGetAvatarMutation, useUploadAvatarMutation } = avatarApi;
